import React from 'react';
import PropTypes from 'prop-types';
import ApplianceConditionRulesContainer from '../rules/ApplianceConditionRulesContainer';
import AutoCompleteFilter from 'components/list/Filters/types/AutoCompleteFilter';
import MenuItem from 'material-ui/MenuItem';
import RenderBooleanInputField from 'components/form/InputFields/RenderBooleanInputField';
import MobianDateTimeInput from 'components/input/MobianDateTimeInput';
import RenderNullableAutoCompleteInputField from 'components/form/InputFields/RenderNullableAutoCompleteInputField';
import RenderPercentageInputField from 'components/form/InputFields/RenderPercentageInputField';
import RenderSelectInputField from 'components/form/InputFields/RenderSelectInputField';
import RenderTextInputField from 'components/form/InputFields/RenderTextInputField';
import SubmitButton from 'components/button/SubmitButton';
import authHelper from 'helpers/auth';
import utils from 'helpers/utils';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { Field, isInvalid, reduxForm } from 'redux-form';
import { connect } from 'react-redux';

class DiscountsCreateForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.currencies = context.config.currency.supported;
    }

    onUpdateRules = (rules) => {
        const { change } = this.props;

        utils.each(rules, (rule, key) => {
            change(key, rule);
        });
    };

    render() {
        const {
            formValues,
            handleSubmit,
            handleSubmitForm,
            invalid,
            pristine,
            submitting,
            translate,
        } = this.props;

        const isAdmin = authHelper.isAdmin();

        const usesDiscountCodes = [
            {
                label: translate('resources.discounts.types.global'),
                value: 0,
            },
            {
                label: translate('resources.discounts.types.regular'),
                value: 1,
            },
        ];

        const currencies = utils.map(this.currencies, (currency) => {
            return {
                label: currency,
                value: currency,
            };
        });

        const isGlobalDiscount = !utils.isEmpty(formValues.values) && formValues.values.uses_discount_codes === 0;

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section>
                        { isAdmin &&
                            <Row>
                                <Item>
                                    <Field
                                        component={ AutoCompleteFilter }
                                        label='resources.discounts.fields.accountId'
                                        name='account_id'
                                        optionValue='id'
                                        reference='accounts'
                                        searchBy='name'
                                        searchParams={ {
                                            size: '12',
                                            sort_by: 'name',
                                            sort_direction: 'asc',
                                        } }
                                        source='account_id'
                                    />
                                </Item>
                            </Row>
                        }

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderSelectInputField }
                                    fullWidth={ false }
                                    label={ translate('resources.discounts.fields.uses_discount_codes') }
                                    optionText='label'
                                    optionValue='value'
                                    name='uses_discount_codes'
                                    validate={ validations.number }
                                >
                                    {
                                        utils.map(usesDiscountCodes, (option) => {
                                            return <MenuItem
                                                key={ `uses_discount_codes_${ option.value }` }
                                                primaryText={ option.label }
                                                value={ option.value }
                                            />;
                                        })
                                    }
                                </Field>
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderBooleanInputField }
                                    fullWidth={ false }
                                    label={ translate('resources.discounts.fields.apply_on_fees') }
                                    name='apply_on_fees'
                                />
                            </Item>
                        </Row>

                        <Row>
                            <Item>
                                <Field
                                    component={ RenderTextInputField }
                                    fullWidth={ true }
                                    label={ translate('resources.discounts.fields.title') }
                                    name='title'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>
                    </Section>

                    { isGlobalDiscount &&
                        <div>
                            <Section>
                                <Row>
                                    <Item>
                                        <Field
                                            component={ RenderTextInputField }
                                            fullWidth={ false }
                                            label={ translate('resources.discounts.fields.priority') }
                                            optionText='label'
                                            optionValue='value'
                                            name='priority'
                                            validate={ validations.number }
                                        />
                                    </Item>
                                </Row>

                                <Row>
                                    <Item>
                                        <Field
                                            component={ MobianDateTimeInput }
                                            floatingLabelFixed={ true }
                                            fullWidth={ true }
                                            label={ translate('resources.discounts.fields.expiry_date') }
                                            name='expiry_date'
                                            resource='expiry_date'
                                        />
                                    </Item>
                                </Row>
                            </Section>

                            <Section>
                                <Row>
                                    <Item>
                                        <Field
                                            choices={ currencies }
                                            component={ RenderNullableAutoCompleteInputField }
                                            fullWidth={ false }
                                            label={ translate('resources.discounts.fields.currency') }
                                            name='currency'
                                            optionText='label'
                                            optionValue='value'
                                            startingValue={ null }
                                        />
                                    </Item>
                                </Row>

                                <Row>
                                    <Item>
                                        <Field
                                            component={ RenderTextInputField }
                                            fullWidth={ true }
                                            label={ translate('resources.discounts.fields.amount') }
                                            name='amount'
                                            type='number'
                                        />
                                    </Item>
                                </Row>

                                <Row>
                                    <Item>
                                        <Field
                                            component={ RenderPercentageInputField }
                                            fullWidth={ true }
                                            label={ translate('resources.discounts.fields.percentage') }
                                            name='percentage'
                                        />
                                    </Item>
                                </Row>
                            </Section>
                        </div>
                    }

                    <Section>
                        <ApplianceConditionRulesContainer updateRules={ this.onUpdateRules } />
                    </Section>

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ pristine || submitting || invalid }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

DiscountsCreateForm.contextTypes = {
    config: PropTypes.object,
};

DiscountsCreateForm.propTypes = {
    change: PropTypes.func.isRequired,
    formValues: PropTypes.shape({
        values: PropTypes.shape({
            uses_discount_codes: PropTypes.number,
        }),
    }),
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    pristine: PropTypes.bool.isRequired,
    submitting: PropTypes.bool.isRequired,
    translate: PropTypes.func.isRequired,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
        formValues: state.form[form] || {},
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm({
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;

            if (!values.user_id) {
                errors.user_id = translate('forms.required');
            }

            if (!values.name) {
                errors.name = translate('forms.required');
            }

            return errors;
        },
    }),
);

export default enhance(DiscountsCreateForm);



// WEBPACK FOOTER //
// ./src/pages/discounts/create/DiscountsCreateForm.js